import { Component, Input, OnInit, Output } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-detail-demande",
	templateUrl: "./detail-demande.component.html",
})
export class DetailDemandeComponent implements OnInit {
	@Input() hidden: boolean = false;
	@Input() priorite: string = "";
	@Input() demandeur: any;
	@Input() superviseur: any;
	@Input() dateDemande: string = "";
	@Input() prixTotal: number = 0;
	@Input() isDisabledpriorite = false;
	constructor() {}

	ngOnInit() {}
}
